import { join, toText, isNullOrWhiteSpace, printf, toFail } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { record_type, array_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { CustomerInfo, Machine_$reflection } from "../Shared/ApiDataTypes.js";
import { choose, sortBy, sumBy, map, partition } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { Array_distinct } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";
import { curry2, defaultOf, int32ToString, createObj, comparePrimitives, stringHash } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { FSharpSet__Contains, add, remove, contains, ofSeq } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.8.0/ReactInterop.js";
import { Customer_fetchCustomers } from "../Promises.js";
import { some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { createDisposable } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { strIContains, Machine_getNameOrCode } from "../Shared/Shared.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Divider, Typography, Link } from "@mui/material";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { singleton, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Components_Searchbar_25F45B5E } from "../Components/Searchbar.js";
import { Components_Filterbar_Z27381C84 } from "../Components/Filterbar.js";
import { ComponentsModule_Chip_Level, Components_Chip_51BC9844 } from "../Components/Chip.js";
import CheckCircle from "@mui/icons-material/CheckCircle";
import Cancel from "@mui/icons-material/Cancel";

function AgreementFilterModule_toLocalizedString(locale, filter) {
    switch (filter) {
        case 0:
            return locale.t("Customer.HasAgreement");
        case 1:
            return locale.t("Customer.HasNotAgreement");
        default:
            return toFail(printf("Unexpected agreement filter enum value %A"))(filter);
    }
}

class SubGroupEntry extends Record {
    constructor(SubgroupName, Machines) {
        super();
        this.SubgroupName = SubgroupName;
        this.Machines = Machines;
    }
}

function SubGroupEntry_$reflection() {
    return record_type("Kundeweb.CustomerGroup.SubGroupEntry", [], SubGroupEntry, () => [["SubgroupName", string_type], ["Machines", array_type(Machine_$reflection())]]);
}

function mapCustomerSubMachines(customer) {
    const patternInput = partition((m) => isNullOrWhiteSpace(m.SubGroup), customer.Machines);
    const withSubgroup = patternInput[1];
    return [new CustomerInfo(customer.Id, customer.Number, customer.Name, customer.Enabled, customer.EnableServices, customer.EnableExtra, customer.HasAgreement, customer.Favorite, customer.Memo, customer.Responsible, customer.ServiceLead, patternInput[0], customer.MarketCategories, customer.Groups), map((subgroupName) => (new SubGroupEntry(subgroupName, withSubgroup.filter((m_2) => (m_2.SubGroup === subgroupName)))), Array_distinct(map((m_1) => m_1.SubGroup, withSubgroup), {
        Equals: (x, y) => (x === y),
        GetHashCode: stringHash,
    }))];
}

export function CustomerOverview(customerOverviewInputProps) {
    let elems_10;
    const groupId = customerOverviewInputProps.groupId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState([]);
    const customers = patternInput[0];
    const patternInput_1 = reactApi.useState("");
    const searchTerm = patternInput_1[0];
    let patternInput_2;
    const initial_2 = ofSeq([0, 1], {
        Compare: comparePrimitives,
    });
    patternInput_2 = reactApi.useState(initial_2);
    const setAgreementFilter = patternInput_2[1];
    const agreementFilter = patternInput_2[0];
    const customerCount = customers.length | 0;
    const machineCount = sumBy((tupledArg) => {
        const subMachines = sumBy((_arg) => _arg.Machines.length, tupledArg[1], {
            GetZero: () => 0,
            Add: (x_1, y_1) => (x_1 + y_1),
        }) | 0;
        return (tupledArg[0].Machines.length + subMachines) | 0;
    }, customers, {
        GetZero: () => 0,
        Add: (x_2, y_2) => (x_2 + y_2),
    }) | 0;
    useEffectWithDeps(() => {
        let active = true;
        const pr = Customer_fetchCustomers(new Int32Array([groupId]));
        pr.then((res) => {
            if (res.tag === 0) {
                if (active) {
                    patternInput[1](map(mapCustomerSubMachines, res.fields[0]));
                }
                else {
                    console.debug("[GroupCustomerOverview] Got customers while not active");
                }
            }
            else {
                console.error(some("Could not fetch customers"));
            }
        });
        return createDisposable(() => {
            active = false;
        });
    }, [groupId]);
    const machineListEntry = (customerId, machine_1) => {
        let elems;
        const machineNameOrCode = Machine_getNameOrCode({
            code: machine_1.Code,
            name: machine_1.Name,
        });
        return createElement("div", createObj(singleton((elems = [MuiHelpers_createElement(Link, [["key", `${machine_1.Id}`], ["title", isNullOrWhiteSpace(machine_1.Code) ? machine_1.Name : toText(printf("%s / %s"))(machine_1.Name)(machine_1.Code)], ["href", RouterModule_encodeParts(ofArray(["group", int32ToString(groupId), "customer", int32ToString(customerId), "machine", int32ToString(machine_1.Id)]), 1)], ["underline", "none"], ["variant", "body1"], ["classes.root", "text-overflow"], ["sx", {
            display: "block",
        }], ["children", machineNameOrCode]])], ["children", reactApi.Children.toArray(Array.from(elems))]))));
    };
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        width: 100 + "%",
        rowGap: 30 + "px",
    }], (elems_10 = toList(delay(() => {
        let elems_2, elems_1, customerCount_1, machineCount_1;
        return append(singleton_1(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
            columnGap: 30 + "px",
            rowGap: 10 + "px",
        }], (elems_2 = [createElement(Components_Searchbar_25F45B5E, {
            placeholder: ctx.Locale.t("Group.Search"),
            onChange: (ev) => {
                const value_35 = ev.target.value;
                console.debug("Search term update", value_35);
                patternInput_1[1](value_35);
            },
            sx: some({
                flexBasis: 320 + "px",
            }),
        }), createElement(Components_Filterbar_Z27381C84, {
            children: [createElement(Components_Chip_51BC9844, {
                key: "active-agreements",
                $key: "active-agreements",
                primary: ctx.Locale.t("Group.ActiveAgreements"),
                enabled: contains(0, agreementFilter),
                onClick: () => {
                    setAgreementFilter(contains(0, agreementFilter) ? remove(0, agreementFilter) : add(0, agreementFilter));
                },
                colorLevel: new ComponentsModule_Chip_Level(1, []),
            }), createElement(Components_Chip_51BC9844, {
                key: "inactive-agreements",
                $key: "inactive-agreements",
                primary: ctx.Locale.t("Group.InactiveAgreements"),
                enabled: contains(1, agreementFilter),
                onClick: () => {
                    setAgreementFilter(contains(1, agreementFilter) ? remove(1, agreementFilter) : add(1, agreementFilter));
                },
            })],
            expanded: false,
            expandable: false,
        }), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            columnGap: 20 + "px",
        }], (elems_1 = [MuiHelpers_createElement(Typography, [["children", (customerCount_1 = int32ToString(customerCount), ctx.Locale.t("Group.AmountCompanies", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf(),["customerCount", customerCount_1])))]]), MuiHelpers_createElement(Typography, [["children", (machineCount_1 = int32ToString(machineCount), ctx.Locale.t("Group.AmountMachines", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf(),["machineCount", machineCount_1])))]])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let elems_3;
            return append((customers.length === 0) ? singleton_1(createElement("div", createObj(ofArray([["style", {}], (elems_3 = [createElement("span", {
                style: {
                    fontStyle: "italic",
                    fontSize: 0.8 + "rem",
                },
                children: ctx.Locale.t("Group.NoCompanies"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : empty(), delay(() => {
                let elems_9;
                return singleton_1(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 30 + "px",
                }], (elems_9 = [map((tupledArg_3) => {
                    let elems_8, elems_4, elems_7;
                    const c_1 = tupledArg_3[0];
                    const subGroups_1 = tupledArg_3[1];
                    return createElement("div", createObj(ofArray([["className", join(" ", ["gray-rounded-container", "customer-box-item"])], (elems_8 = [createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        columnGap: 20 + "px",
                    }], (elems_4 = toList(delay(() => append(singleton_1(MuiHelpers_createElement(Link, [["title", c_1.Name], ["href", RouterModule_encodeParts(ofArray(["group", int32ToString(groupId), "customer", int32ToString(c_1.Id)]), 1)], ["variant", "h5"], ["underline", "none"], ["classes.root", "text-overflow"], ["sx", {
                        flexGrow: 1,
                    }], ["children", c_1.Name]])), delay(() => (c_1.HasAgreement ? singleton_1(createElement(Components_Chip_51BC9844, {
                        key: "",
                        $key: "",
                        primary: ctx.Locale.t("Group.ActiveAgreements"),
                        enabled: true,
                        startIcon: (props_9) => {
                            const props_11 = createObj(props_9);
                            return react.createElement(CheckCircle, props_11);
                        },
                        colorLevel: new ComponentsModule_Chip_Level(1, []),
                    })) : singleton_1(createElement(Components_Chip_51BC9844, {
                        key: "",
                        $key: "",
                        primary: ctx.Locale.t("Group.InactiveAgreements"),
                        enabled: true,
                        startIcon: (props_12) => {
                            const props_14 = createObj(props_12);
                            return react.createElement(Cancel, props_14);
                        },
                    }))))))), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), MuiHelpers_createElement(Divider, []), createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        overflowY: "scroll",
                        maxHeight: 250,
                        rowGap: 10 + "px",
                    }], (elems_7 = toList(delay(() => (((c_1.Machines.length === 0) && (subGroups_1.length === 0)) ? singleton_1(createElement("div", {
                        style: {
                            color: "hsl(207.3, 30%, 28%)",
                            fontStyle: "italic",
                        },
                        children: MuiHelpers_createElement(Typography, [["variant", "subtitle1"], ["children", `${ctx.Locale.t("Group.NoMachines")}`]]),
                    })) : append(singleton_1(map((s_1) => {
                        let elems_6, elems_5;
                        return createElement("div", createObj(ofArray([["style", {}], (elems_6 = [MuiHelpers_createElement(Typography, [["children", s_1.SubgroupName]]), createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "column",
                            rowGap: 5 + "px",
                            borderLeft: ((((1 + "px") + " ") + "dashed") + " ") + "var(--navy)",
                            padding: ((((((0 + "px ") + 0) + "px ") + 0) + "px ") + 10) + "px",
                        }], (elems_5 = map(curry2(machineListEntry)(c_1.Id), s_1.Machines), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
                    }, sortBy((s) => s.SubgroupName, subGroups_1, {
                        Compare: comparePrimitives,
                    }))), delay(() => singleton_1(map(curry2(machineListEntry)(c_1.Id), c_1.Machines))))))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
                }, sortBy((tupledArg_2) => tupledArg_2[0].Name, customers.filter((tupledArg_1) => {
                    const customer_2 = tupledArg_1[0];
                    const sub = choose((subGroup) => {
                        const filteredMachines = subGroup.Machines.filter((machine) => strIContains(searchTerm, machine.Name));
                        if (filteredMachines.length === 0) {
                            return undefined;
                        }
                        else {
                            return new SubGroupEntry(subGroup.SubgroupName, filteredMachines);
                        }
                    }, tupledArg_1[1]);
                    const filteredCustomer = new CustomerInfo(customer_2.Id, customer_2.Number, customer_2.Name, customer_2.Enabled, customer_2.EnableServices, customer_2.EnableExtra, customer_2.HasAgreement, customer_2.Favorite, customer_2.Memo, customer_2.Responsible, customer_2.ServiceLead, customer_2.Machines.filter((m) => strIContains(searchTerm, m.Name)), customer_2.MarketCategories, customer_2.Groups);
                    const searched = (strIContains(searchTerm, filteredCustomer.Name) ? true : !(filteredCustomer.Machines.length === 0)) ? true : !(sub.length === 0);
                    const withAgreementOnly = filteredCustomer.HasAgreement && FSharpSet__Contains(agreementFilter, 0);
                    const withoutAgreementOnly = !filteredCustomer.HasAgreement && FSharpSet__Contains(agreementFilter, 1);
                    if (isNullOrWhiteSpace(searchTerm) ? true : searched) {
                        if (withAgreementOnly) {
                            return true;
                        }
                        else {
                            return withoutAgreementOnly;
                        }
                    }
                    else {
                        return false;
                    }
                }), {
                    Compare: comparePrimitives,
                }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_10))])])));
}

